<template>
    <div>
        <div class="sub-lnb-menu">
            <ul class="sub-lnb-menu__list">
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==1}" @click="lnbFn(1)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step1')">重症监护室提供的<br>服务与注意事项</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==2}" @click="lnbFn(2)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step2')">准备物品</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==3}" @click="lnbFn(3)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step3')">查房信息</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==4}" @click="lnbFn(4)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step4')">供餐信息</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==5}" @click="lnbFn(5)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step5')">探病通知及注意事项</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==6}" @click="lnbFn(6)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step6')">其他事项</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==7}" @click="lnbFn(7)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step7')">重症监护室住院时<br>所需物品清单</a>
                </li>
            </ul>
        </div>

        <div class="subSwiper info" v-if="$store.getters.getHost == 'H0006'">
            <swiper :cssMode="true" :navigation="{
					nextEl: '.subSwiper-next',
					prevEl: '.subSwiper-prev'
				}" :pagination="{ clickable: true }" :mousewheel="true" :keyboard="true" :modules="modules">
                <swiper-slide>
                    <img src="/resource/img/info-img02.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img03.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img04.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="subSwiper-bth subSwiper-next"></div>
            <div class="subSwiper-bth subSwiper-prev"></div>
        </div>

        <!-- 뇌혈관 -->
        <div class="subSwiper info" v-else>
            <swiper :cssMode="true" :pagination="{ clickable: true }" :mousewheel="true" :keyboard="true" :modules="modules">
                <swiper-slide>
                    <img src="/resource/img/intensive01-brain.jpg" alt="">
                </swiper-slide>
            </swiper>
        </div>

        <div id="step1" class="step-item info">
            <h3 class="bullet01">重症监护室提供的服务与注意事项</h3>
            <p class="bullet04 num1 depth">提供吸痰、改变体位、局部洗澡、排尿、排便管理和饮食协助等基本护理服务。</p>
            <p class="bullet04 num2 depth">紧急情况下呼叫方法：在紧急情况下或需要护士帮助时，可以通过按下床边的紧急铃呼叫护士来获得帮助。</p>
            <p class="bullet04 num3 depth">为了进行感染管理及重症监护室特殊治疗，患者可能在重症监护室内更换病房。</p>
            <p class="bullet04 num4 depth">
                <span>
                    为了维护各种管类(导管、引流管、导流管等)以及人工呼吸器、体外循环器等直接影响患者呼吸系统和心血管系统的医疗器械或设备，预防患者自残或伤害他人，可使用身体保护带，程序如下
                    <span class="font-main">可使用身体保护带,</span> 
                    程序如下
                </span>
            </p>
            <p class="bullet05 depth">
                关于使用身体保护带的必要性，负责医生需向患者或其监护人进行说明，并在使用后至少每两小时对使用部位进行一次观察。
            </p>
            <p class="bullet05 depth">
                紧急情况下，医疗团队可以在先使用后，向监护人进行说明。
            </p>
            <p class="bullet04 num5 depth">
                请在住院前告知负责医生和护士患者自带药品的情况，患者在住院前不得随意服用自带药品。
            </p>
        </div>
        <div id="step2" class="step-item info">
            <h3 class="bullet01">准备物品</h3>
            <p class=" depth">请准备患者使用的湿巾、纸尿裤、铺垫和口罩。</p>
        </div>
        <div id="step3" class="step-item info">
            <h3 class="bullet01">查房信息</h3>
            <p class="bullet04 num1 depth">查房时间为上午8点~10点，根据诊疗科情况可能会有所变动。</p>
            <p class="bullet04 num2 depth">如果希望在查房时面谈，请告诉负责护士。</p>
        </div>
        <div id="step4" class="step-item info">
            <h3 class="bullet01">供餐信息</h3>
            <p class="bullet04 num1 depth">能进食的患者用餐时间为：早餐: 上午7~8点，午餐：中午12~1点，晚餐：下午6~7点。</p>
            <p class="bullet04 num2 depth">如果患者愿意，可以选择非医保餐“特别餐”，这种情况下费用全部由本人承担。</p>
        </div>
        <div id="step5" class="step-item info">
            <h3 class="bullet01">探病通知及注意事项</h3>
            <p class="bullet04 num1 depth">正规探病时间</p>
            <div class="table mt20 ">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:25%;">
                            <col style="width:25%;">
                            <col style="width:25%;">
                            <col style="width:25%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th colspan="2">区分</th>
                                <th>星期</th>
                                <th>时间</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td rowspan="2">综合重症监护室</td>
                                <td>综合重症监护室</td>
                                <td>每天</td>
                                <td rowspan="4">13:00 ~ 13:20</td>
                            </tr>
                            <tr>
                                <td>内科系统重症监护室</td>
                                <td>每天</td>
                            </tr>
                            <tr>
                                <td rowspan="2">外科重症监护室</td>
                                <td>外科系统重症监护室</td>
                                <td>每天</td>
                            </tr>
                            <tr>
                                <td>心血管重症监护室</td>
                                <td>每天</td>
                            </tr>
                            <tr>
                                <td>主动脉血管重症监护室</td>
                                <td>主动脉血管重症监护室</td>
                                <td>每天</td>
                                <td>12:30 ~ 12:50</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <p class="bullet04 num2 depth mt20">根据重症监护室的情况，探病可能会受到限制或延迟。</p>
            <p class="bullet04 num3 depth">为了控制感染，探病者限制为1人，不能交替。</p>
            <p class="bullet04 num4 depth">为了患者的稳定和预防感染，禁止免疫力较弱的12岁以下儿童或患有感冒及传染性疾病的家人探病，并请遵守探病时间。</p>
            <p class="bullet04 num5 depth">探病前后请务必使用手消毒剂或在重症监护室入口的洗手池洗手。</p>
            <p class="bullet04 num6 depth">探病时，请穿上重症监护室入口处提供的塑料隔离衣，并在离开重症监护室前，脱下塑料隔离衣，洗手后离开。</p>
            <p class="bullet04 num7 depth">探病时，为预防患者坠床，请遵守以下事项。</p>
            <p class="bullet05 depth">请始终抬起床两侧的栏杆。</p>
            <p class="bullet05 depth">如果需要帮助,请喊护士或按铃呼叫护士。</p>
            <p class="bullet04 num8 depth">在重症监护室请务必关闭手机，否则可能会因无线电干扰而导致医疗设备故障。</p>
            <p class="bullet04 num9 depth">探病过程中如发现患者有异常表现(如意识改变、胸痛、出血、抽搐、疼痛等)，请立即通知医护人员。</p>
            <p class="bullet04 num10 depth">对于儿童患者，为了确保安全，预防被诱拐，探病时可能会对探视者进行身份验证程序。</p>
            <p class="bullet04 num11 depth">请配合医院填写管理访客的访客名册。</p>
        </div>

        <div id="step6" class="step-item info">
            <h3 class="bullet01">其他事项</h3>
            <h4 class="bullet02 type2 num1 depth">便利设施</h4>
            <p class="depth">
                有无人医疗缴费机、影像CD登记机、便利店、银行、咖啡厅、美食广场、面包店、医疗器械、无人快递箱等。
            </p>

            <h4 class="bullet02 type2 num2 depth">预防火灾及发生火灾时的应对方法</h4>
            <p class="depth">
                家庭候诊室内请勿使用便携式煤气灶、电风扇、电热器及携带易燃、可燃物质。一旦发生火灾，请立即通知医院工作人员并按照工作人员的指示通过疏散室和紧急楼梯疏散。
            </p>

            <h4 class="bullet02 type2 num3 depth">禁烟</h4>
            <p class="depth">医院为了患者的健康和预防火灾，整个设施都是禁烟区，请配合禁烟。</p>

            <h4 class="bullet02 type2 num4 depth">处理投诉和不满</h4>
            <p class="depth">若您在医院就诊期间遇到任何疑问、不便之处或希望表达称赞，您可以前往位于一楼的顾客服务室、拨打服务热线、访问医院官方网站进行反馈。</p>

            <h4 class="bullet02 type2 num5 depth">停车费</h4>
            <p class="depth">请参阅重症监护室入口处的布告栏上张贴的停车费信息。</p>

            <h4 class="bullet02 type2 num6 depth">谨防丢失及失窃</h4>
            <p class="depth">
                重症监护室不能存放贵重物品和现金。请个人保管或咨询院务科。假牙、助听器、眼镜、隐形眼镜等辅助器具应在检查、治疗及手术、紧急情况时取下，并请妥善保管。
                <br>
                因本人不慎发生丢失时，本医疗中心概不负责。
            </p>

            <h4 class="bullet02 type2 num7 depth">持有物品管理 </h4>
            <ul class="bullet-list type2 depth">
                <li class="bullet-item">已将</li>
                <li class="bullet-item">眼镜 </li>
                <li class="bullet-item">假牙 </li>
                <li class="bullet-item">助听器 </li>
                <li class="bullet-item">钱包 </li>
                <li class="bullet-item">手机 </li>
                <li class="bullet-item">衣服 </li>
                <li class="bullet-item">鞋子 </li>
                <li class="bullet-item">钥匙 </li>
                <li class="bullet-item">手表 </li>
                <li class="bullet-item">耳环 </li>
                <li class="bullet-item">项链 </li>
                <li class="bullet-item">戒指 </li>
                <li class="bullet-item">手链  </li>
                <li class="bullet-item">脚链  </li>
                <li class="bullet-item">其他( <span class="gap50"></span> ) 转交给(姓名: <span class="gap100"></span>关系: <span class="gap100"></span>) 先生/女士。</li>
            </ul>


            <h4 class="bullet02 type2 num8 depth">宗教设施指南</h4>
            <p class="depth">
                本院是基督教医院，周日礼拜时间为周日上午10点，周三礼拜时间为周三下午5点，儿童/青少年礼拜时间为周四上午10点，在C馆3楼方舟教会进行。探访病房、信仰咨询、其他宗教咨询等可致电院牧咨询室(02-6986-5724)，院牧咨询室和祈祷室位于C馆3楼。
            </p>

            <h4 class="bullet02 type2 num9 depth">出院程序指南</h4>
            <p class="depth">
                出院保险审核后，将向患者或监护人发送短信。缴纳住院费可以使用院务科住出院窗口或无人缴费机，缴费后在护士室领取出院药品即可。
            </p>

            <h4 class="bullet02 type2 num10 depth">签发各种证明文件</h4>
            <p class="depth">
                请提前告知您的负责医生或护士需要的文件，例如诊断书、病历和影像副本。
            </p>

            <h4 class="bullet02 type2 num11 depth">我们在所有治疗过程中尊重并保护患者的权利和义务。</h4>
            <div class="table mt20">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:50%;">
                            <col style="width:50%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>患者的权利</th>
                                <th>患者的义务</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num1">接受诊疗的权利</p>
                                </td>
                                <td class="left" rowspan="2">
                                    <p class="bullet04 num1">对医务人员的信任和尊重义务</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num2">知情权和自主决定权</p>
                                </td>
                            </tr>


                            <tr>
                                <td class="left">
                                    <p class="bullet04 num3">保密权</p>
                                </td>
                                <td class="left" rowspan="3">
                                    <p class="bullet04 num2">不以不正当手段接受诊疗的义务</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num4">申请商谈调解的权利</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num5">在安全的医疗环境中获得医疗服务的权利</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <h4 class="bullet02 type2 num12 depth mt20">
                患者或监护人(来访者)因暴力(恶语相向、威胁、骚乱、性暴力、性骚扰、损坏公物等)行为对工作人员造成损害的，可依据有关法令予以处罚。
            </h4>

            <h4 class="bullet02 type2 num13 depth mt20">
                发生患者或监护人等对医务人员可能构成侮辱罪、名誉毁损罪、暴行罪、妨碍公务罪等情况，使医务人员不能进行正常行医时，可以在不违反《医疗法》和《应急医疗法》的范围内拒绝诊疗(拒绝诊疗权)。
            </h4>

            <h4 class="bullet02 type2 num14 depth mt20">
                住院期间可通过CCTV观察患者状态，但不能录像。
            </h4>

        </div>

        <div id="step7" class="step-item info">
            <h3 class="bullet01">重症监护室住院时所需物品清单</h3>

            <h4 class="bullet02 depth">重症监护室探病指南</h4>
            <p class="depth">重症监护室内正规探病时间：每日 <span class="font-main">(12:30~12:50)</span></p>

            <h4 class="bullet02 depth">从重症监护室转普通病房的信息</h4>
            <p class="depth">从重症监护室转入普通病房时，需要有能够提供24小时护理的护工或监护人。可以行动的患者请准备拖鞋。</p>

            <h4 class="bullet02 depth">其他信息</h4>
            <p class="depth">发生超紧急患者时，根据医生的诊疗和判断，无论时间如何，患者都有可能被紧急更换病房，敬请谅解。</p>

            <h4 class="bullet02 depth">重症监护室所需物品</h4>
            <div class="need-item">
                <div class="need-item__text">
                    <p class="bullet04 num1 depth">住院前服用药物(本院药物除外)</p>
                    <p class="bullet04 num2 depth">纸尿裤(护翼型O、内裤型X)</p>
                    <p class="bullet04 num3 depth">铺垫、湿巾(大型)</p>
                    <p class="bullet04 num4 depth">凡士林唇膏</p>
                    <p class="bullet04 num5 depth">纸杯、矿泉水500ml*2(必要时)</p>
                    <p class="bullet04 num6 depth">如果意识清醒：牙刷、牙膏、吸管形水杯、盒装纸巾</p>


                    <!-- <p class="bullet04 num7 depth"><span><span class="font-main">수술 후 환자의 경우</span>(필요시):트리플로우(호흡기치료기)*1</span></p>
                    <p class="bullet05 depth">지하1층 의료기상사에서 구입가능</p> -->
                </div>
                <div class="need-item__img">
                    <img src="@/assets/resource/img/needitem.png" alt="">
                </div>
            </div>

            <h4 class="bullet02 depth">重症监护室内不可保管贵重物品的通知</h4>
            <p class="depth">
                重症监护室不允许使用个人手机。我们对丢失的贵重物品不承担任何责任，因此请带回家保管。戴假牙/助听器时请告知医护人员。
            </p>

            <h4 class="bullet02 depth">可购买物品的地方</h4>
            <p class="bullet03 depth">24小时 : <span class="font-main">地下1层CU便利店</span></p>
            <p class="bullet03 depth">周一~周五 9am~6pm :<span class="font-main">地下1层医疗器械商店</span></p>
        </div>

    </div>
</template>
<script>
    // Import Swiper Vue.js components
    import { Swiper, SwiperSlide } from 'swiper/vue';

    // Import Swiper styles
    import 'swiper/css';

    import 'swiper/css/navigation';
    import 'swiper/css/pagination';

    import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        setup() {
            return {
                modules: [Navigation, Pagination, Mousewheel, Keyboard],
            };
        },
        data() {
            return {
                lnbIndex: 1,
            };
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            scrollTo(id) {
                const element = document.getElementById(id);
                if (element) {
                    // 해당 요소의 위치와 크기 정보 가져오기
                    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;

                    // 스크롤을 이동할 위치를 계산 (100px 추가)
                    const scrollToPosition = elementTop - 100;

                    // 계산된 위치로 부드럽게 스크롤
                    window.scrollTo({
                    top: scrollToPosition,
                    behavior: 'smooth'
                    });
                }
            },
            handleScroll() {
                const sections = document.querySelectorAll('.step-item');
                sections.forEach((section, index) => {
                    const rect = section.getBoundingClientRect();
                    // Check if the top of the section is within the viewport
                    if (rect.top <= 101 && rect.top <= window.innerHeight) {
                        this.lnbIndex = index + 1; // Update lnbIndex based on the section's position
                    }
                });
            },
            lnbFn(index) {
                this.lnbIndex = index; // Change the active index when clicking the menu
            },
        },
    };
</script>